import api from '../../api'
import { IssuePersonalTokenResult, PersonalTokenPrecheckResult } from './tokensModel'

export const getPersonalTokenPrecheck = async (email: string): Promise<PersonalTokenPrecheckResult> =>
  (await api.get('/web/admin/personal-tokens/precheck', { params: { email } })).data

export const issuePersonalToken = async (email: string): Promise<IssuePersonalTokenResult> =>
  (await api.post('/web/admin/personal-tokens', { email })).data
